import { Component, OnInit } from '@angular/core';
import {  NavController, NavParams,ToastController,LoadingController,ViewController,AlertController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DTOObterLote } from '../../dto/dtoObterLote';
import { LoteDAO } from '../../daos/lote-dao';
import { DefeitoLote} from '../../entities/defeito-lote';
import { RecebeLote } from '../../entities/recebe-lote';
import { DefeitoGrupo } from '../../entities/defeito-grupo';
import { DefeitoTipo } from '../../entities/defeito-tipo';
import { Usuario } from '../../entities/usuario';
import {NgxImageCompressService} from 'ngx-image-compress';

@Component({
  selector: 'page-inspecionar-lote-novo',
  templateUrl: 'inspecionar-lote-novo.html',
})

export class InspecionarLoteNovoPage implements OnInit {
  public dtoObterLote: DTOObterLote;
  public defeitoLote: DefeitoLote = new DefeitoLote();
  public recebeLote: RecebeLote = new RecebeLote();
  public usuario: Usuario; 
  public base64Image: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII=';
  

  public defeitoRetrabalhoGrupo: DefeitoGrupo[] = [];
  public defeitoRetrabalhoTipo: DefeitoTipo[] = [];
  public defeito2qGrupo: DefeitoGrupo[] = [];
  public defeito2qTipo: DefeitoTipo[] = [];
  defeitoLoteRetrabalho: DefeitoLote[] = [];
  defeitoLote2Qualidade: DefeitoLote[] = [];
  
  calcQtde1Qualidade: number;
  teveAlteracao: boolean = false;
  public typeSegmento: string; 
  

  adicionarRetrabalhoForm: FormGroup;
  adicionar2QualidadeForm: FormGroup;

  constructor(public navCtrl: NavController,_navParams: NavParams,
    _formBuilder: FormBuilder,
    private _loteDAO: LoteDAO,
    public navParams: NavParams,
    private _viewCtrl: ViewController,
    private _alertCtrl: AlertController,
    private _loadingCtrl: LoadingController,
    private imageCompress: NgxImageCompressService,
    private _toastCtrl: ToastController) {
      this.dtoObterLote = _navParams.get('dtoObterLote');
      this.usuario = _navParams.get('usuario');  
      this.adicionarRetrabalhoForm = _formBuilder.group({
        qtdeRetrabalho: ['', Validators.required], 
        gpDefeitoRetrabalho: ['', Validators.compose([Validators.required])],    
        tpDefeitoRetrabalho: ['', Validators.compose([Validators.required])]
      });

      this.adicionar2QualidadeForm = _formBuilder.group({
        qtdeSegQualidade: ['', Validators.required], 
        gpDefeitoSegQualidade: ['', Validators.compose([Validators.required])],    
        tpDefeitoSegQualidade: ['', Validators.compose([Validators.required])]
      });
  }

  ngOnInit(): void {
    this.typeSegmento = '1';
    this.recebeLote = this.dtoObterLote.RecebeLote; 
    if (this.recebeLote.ImgInspecao != null)
    this.base64Image = this.recebeLote.ImgInspecao;
    this.calcQtde1Qualidade = this.dtoObterLote.Quantidade - this.dtoObterLote.QtdeTotDefeitoSegQualidade - this.recebeLote.QtdeIrrecuperavel;
       
    
    if (this.dtoObterLote.DefeitoLote !== null){
      this.defeitoLoteRetrabalho = this.dtoObterLote.DefeitoLote.filter(a => a.Tipo == 'R');  
      this.defeitoLote2Qualidade = this.dtoObterLote.DefeitoLote.filter(a => a.Tipo == 'S'); 
    }    
    
    let load = this._loadingCtrl.create({ content: 'Obtendo grupos e tipos...' });
    load.present();
    Promise.all([
        this._loteDAO.obterDefeitoGrupo(this.dtoObterLote.RecebeLote.Empresa.Id)
    ]).then(res => {
        this.defeito2qGrupo = res[0];        
        this.defeitoRetrabalhoGrupo = res[0];          
        load.dismiss();
    }).catch(error => {
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter os grupos e os tipos. Tente novamente!'+error,
            duration: 3000
        }).present();
        load.dismiss();
    });
  }

/*
  public selDefeito2qGrupo(idDefeitoGrupo: any) {    
      this.defeito2qTipo = [];  
      //this.defeitoTipo = this.defeitoGrupo[idDefeitoGrupo-1].DefeitoTipo;
      this.defeito2qTipo = this.defeito2qGrupo.filter((item) => { return item.Id == idDefeitoGrupo })[0].DefeitoTipo;      
  }
      */

  upload(event:any){
    //var filename = event.target.files[0].name
    var fileReader = new FileReader();
    fileReader.readAsDataURL(event)
    fileReader.onload = () => {
    this.base64Image = fileReader.result.toString();
    //console.log(this.base64ImageFrente.length);

    this.imageCompress.compressFile(this.base64Image, 30, 30).then(result => {
        this.base64Image = result;
          //console.warn('Size in bytes is now:', this.imageCompress.byteCount(result));
        }
      );
    }        
  }

  public selDefeitoGrupoRetrabalho(idDefeitoGrupo: any) {    
    if (idDefeitoGrupo.length > 0) {
      this.defeitoRetrabalhoTipo = [];  
      this.defeitoRetrabalhoTipo = this.defeitoRetrabalhoGrupo.filter((item) => { return item.Id == idDefeitoGrupo })[0].DefeitoTipo;    
    }
  }


  public selDefeitoGrupo2Qualidade(idDefeitoGrupo: any) {    
    if (idDefeitoGrupo.length > 0) {  
      this.defeito2qTipo = [];  
      this.defeito2qTipo = this.defeito2qGrupo.filter((item) => { return item.Id == idDefeitoGrupo })[0].DefeitoTipo;
    }
  }

  public fechar(): void {
    if (!this.dtoObterLote.RecebeLote.DataRevisao) {
      this._alertCtrl.create({ 
        title: 'Deseja registrar a data da inspeção?', 
        subTitle: 'Após registrar a data, o botão liberar lote será habilidato',
        buttons: [
          {
            text: 'Não',            
            handler:() =>{this._viewCtrl.dismiss(this.teveAlteracao)}
          },
          {
            text: 'Sim', 
            handler:() =>{
              this.salvar('Data da Inspeção foi gravada com sucesso!');
              this._viewCtrl.dismiss(true);
            }
          }       
        ] 
      }).present();

    } else  this._viewCtrl.dismiss(this.teveAlteracao);
  }
  
  public salvar(msg: string): void {
      let load = this._loadingCtrl.create({ content: 'Verificando...' });
        load.present();
        this.recebeLote.UsuarioInspecao = this.usuario.Id;
        this.recebeLote.DataInspecao =  new Date();
        if (this.base64Image != 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII=' )
        this.recebeLote.ImgInspecao = this.base64Image;
      this._loteDAO.manterInspecaoLote(this.recebeLote).then(() => {
          load.dismiss().then(() => {
            if (!this.dtoObterLote.RecebeLote.DataRevisao)
              this.dtoObterLote.RecebeLote.DataRevisao = new Date();
              this.teveAlteracao = true;
              this._toastCtrl.create({                               
                  message: msg,
                  duration: 3000
              }).present()
          });
      }).catch((erro) => {
          load.dismiss();
          this._toastCtrl.create({
              message: 'Não foi possível salvar, tente novamente!'+erro,
              duration: 3000
          }).present();
      }); 
  }

  public adicionar2Qualidade(): void {
    if (this.adicionar2QualidadeForm.invalid) {
      this._toastCtrl.create({
          message: 'O formulário está invalido. Favor Verifique!',
          duration: 3000
      }).present();
      return;
    }

    if (this.adicionar2QualidadeForm.valid) {  
      this.defeitoLote.Qtde = this.adicionar2QualidadeForm.get('qtdeSegQualidade').value;
      this.defeitoLote.DefeitoGrupo = this.defeito2qGrupo.find(a => a.Id == this.adicionar2QualidadeForm.get('gpDefeitoSegQualidade').value);  
      this.defeitoLote.DefeitoTipo = this.defeito2qTipo.find(a => a.Id == this.adicionar2QualidadeForm.get('tpDefeitoSegQualidade').value); 
      this.defeitoLote.RecebeLote =  this.recebeLote; 
      this.defeitoLote.Tipo = 'S';   
      this.defeitoLote.Usuario = this.usuario;              
      this._loteDAO.inspecaoNovoLote(this.defeitoLote).then(defeitoLote => {  
        if (!this.dtoObterLote.RecebeLote.DataRevisao)
              this.dtoObterLote.RecebeLote.DataRevisao = new Date();      
        this.defeitoLote2Qualidade.push(defeitoLote);    
        this.teveAlteracao = true;          
      });

      this.adicionar2QualidadeForm.reset();
      /*
      this.adicionar2QualidadeForm.setValue({
        qtdeSegQualidade: '',
        tpDefeitoSegQualidade:'',
        gpDefeitoSegQualidade: '1'
        
      });  
      */

    }  
  }

  
  public adicionarRetrabalho(): void {
    if (this.adicionarRetrabalhoForm.invalid) {
      this._toastCtrl.create({
          message: 'O formulário está invalido. Favor Verifique!',
          duration: 3000
      }).present();
      return;
    }

    if (this.adicionarRetrabalhoForm.valid) {  
      this.defeitoLote.Qtde = this.adicionarRetrabalhoForm.get('qtdeRetrabalho').value;
      this.defeitoLote.DefeitoGrupo = this.defeitoRetrabalhoGrupo.find(a => a.Id == this.adicionarRetrabalhoForm.get('gpDefeitoRetrabalho').value);  
      this.defeitoLote.DefeitoTipo = this.defeitoRetrabalhoTipo.find(a => a.Id == this.adicionarRetrabalhoForm.get('tpDefeitoRetrabalho').value); 
      this.defeitoLote.RecebeLote =  this.recebeLote; 
      this.defeitoLote.Tipo = 'R';  
      this.defeitoLote.Usuario = this.usuario;               
      this._loteDAO.inspecaoNovoLote(this.defeitoLote).then(defeitoLote => {
        if (!this.dtoObterLote.RecebeLote.DataRevisao)
              this.dtoObterLote.RecebeLote.DataRevisao = new Date();
        this.defeitoLoteRetrabalho.push(defeitoLote);  
        this.teveAlteracao = true;            
      });

      this.adicionarRetrabalhoForm.reset();
      

    }  
  }

  removeRegistro(defeitoLote){   
    this._loteDAO.removerDefeito(defeitoLote.Id).then(() => {
      if (defeitoLote.Tipo=='R'){
        let index = this.defeitoLoteRetrabalho.indexOf(defeitoLote);     
        this.defeitoLoteRetrabalho.splice(index, 1)
      } 
      else if (defeitoLote.Tipo=='S') {
        let index = this.defeitoLote2Qualidade.indexOf(defeitoLote);   
        this.defeitoLote2Qualidade.splice(index, 1);
        this.dtoObterLote.QtdeTotDefeitoSegQualidade = this.dtoObterLote.QtdeTotDefeitoSegQualidade  - defeitoLote.Qtde;

        this.calcQtde1Qualidade = this.dtoObterLote.Quantidade 
                            - this.dtoObterLote.QtdeTotDefeitoSegQualidade 
                            - this.recebeLote.QtdeIrrecuperavel;
      }  
      this.teveAlteracao = true;          
    });
      
  }

  onChangeRetrabalho(event){
    if (Number(event) < 0 ){
      event = 0; 
      this.adicionarRetrabalhoForm.patchValue({
        qtdeRetrabalho: 0, 
      });
    }
  }

  onChange2Qualidade(event){
    if (Number(event) < 0 ){
      event = 0; 
      this.adicionar2QualidadeForm.patchValue({
        qtdeSegQualidade: 0, 
      });
    }else{

      this.calcQtde1Qualidade = this.dtoObterLote.Quantidade 
                            - this.dtoObterLote.QtdeTotDefeitoSegQualidade 
                            - this.recebeLote.QtdeIrrecuperavel
                            - Number(event) ;


      if (this.calcQtde1Qualidade  < 0){
        this._toastCtrl.create({
        message: 'Quantidade 2º qualidade informada é maior do que o total do lote 1º Qualidade',
        duration: 3000
        }).present();
        this.defeitoLote.Qtde = 0;
        this.calcQtde1Qualidade = this.dtoObterLote.Quantidade 
                            - this.dtoObterLote.QtdeTotDefeitoSegQualidade 
                            - this.recebeLote.QtdeIrrecuperavel;
        this.adicionar2QualidadeForm.patchValue({
          qtdeSegQualidade: 0, 
        });
      }

    }
     

    
     

  }

  onChangeIrrecuperavel(){    
    if (this.defeitoLote.Qtde == undefined)
        this.defeitoLote.Qtde = 0; 

    this.calcQtde1Qualidade = this.dtoObterLote.Quantidade - this.dtoObterLote.QtdeTotDefeitoSegQualidade - 
    (Number(this.defeitoLote.Qtde) +  Number(this.recebeLote.QtdeIrrecuperavel));

   

    if (this.calcQtde1Qualidade  < 0){
      this._toastCtrl.create({
        message: 'Quantidade irrecuperável informada '+this.recebeLote.QtdeIrrecuperavel+' é maior do que o total do lote 1º Qualidade',
        duration: 3000
      }).present();
      this.recebeLote.QtdeIrrecuperavel = 0;

      this.calcQtde1Qualidade = this.dtoObterLote.Quantidade - 
      (Number(this.defeitoLote.Qtde) +  Number(this.recebeLote.QtdeIrrecuperavel));
    }


  }


}



// WEBPACK FOOTER //
// ./src/pages/inspecionar-lote-novo/inspecionar-lote-novo.ts